import { useQuery } from "@tanstack/react-query";
import { getMRDCByUser } from "@/api/v1-jwt/mrdc/mrdc";
import { useAuth } from "@/providers/auth";

export const useCheckMRDC = ({
  queryFn,
  queryKey,
  status,
  enabled,
  ...rest
} = {}) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const userId =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!userId && enabled !== false;

  return useQuery({
    queryKey: ["mrdc", status],
    queryFn: async () => {
      return await getMRDCByUser({ userId, status });
    },
    enabled: isEnabled,
    ...rest,
  });
};
